import Need from "../Need";

export const NeedSettingsManage = new Need('settings.manage');
